import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosEmpresas from './FiltrosAdicionadosEmpresas'
import FiltroEmpresas from './FiltroEmpresas'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroEmpresas = () => (
  <Filtro PainelFiltro={FiltroEmpresas}/>
);

const PainelFiltrosEmpresas = () => (
  <PainelFiltragem
    Filtro={PainelFiltroEmpresas}
    FiltrosAdicionados={FiltrosAdicionadosEmpresas}/>
)

export default PainelFiltrosEmpresas
